import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseMapper } from "../../utils/mappers/shared/base.mapper";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { SharedMapper } from "../../utils/mappers/shared/_shared.mapper";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { map } from "rxjs/operators";

@Injectable()
export class BaseApiService<T> {
    model: new () => T;
    apiEndPoint: any;
    mapper = new BaseMapper<T>();

    constructor(
        protected http: HttpClient,
        public sharedMapper: SharedMapper
    ) {}

    sharedmapper() {
        return this.sharedMapper;
    }

    getList(filter?: FilterType): Observable<PagedApiResponse<T>> {
        return this.http.post(this.apiEndPoint.list, filter).pipe(
            map((res) => {
                // console.log(res);
                return this.sharedMapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    get(id: number): Observable<T> {
        return this.http
            .get(this.apiEndPoint.item.replace("{id}", id.toString()))
            .pipe(
                map((res) => {
                    return BaseMapper.map(res, this.model);
                })
            );
    }

    create(data: any): Observable<boolean> {
        return this.http.post<boolean>(this.apiEndPoint.base, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    update(data: any): Observable<boolean> {
        return this.http.put<boolean>(
            this.apiEndPoint.item.replace("{id}", data.id.toString()),
            data
        );
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(
            this.apiEndPoint.item.replace("{id}", id.toString())
        );
    }

    activationToggle(id: number): Observable<boolean> {
        return this.http.put<boolean>(
            this.apiEndPoint.activation.replace("{id}", id.toString()),
            null
        );
    }
}
